function Preloader() {
  this.el = null;
}

Preloader.prototype = {
  show() {
    if (!this.el) {
      this.el = document.createElement('div');
      this.el.classList.add('preloader');
      document.body.appendChild(this.el);
    }
  },
  hide() {
    if (this.el) {
      this.el.parentNode.removeChild(this.el);
      this.el = null;
    }
  },
};

export default new Preloader();
